import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryNav() {
  const displayCategories = categories.filter(c => c.slug !== 'all');

  return (
    <section className="py-12 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-2">
            内容分类
          </h2>
          <p className="text-sm text-foreground-500">浏览你感兴趣的内容板块</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-100 hover:bg-secondary-50 border border-background-200/50 hover:border-secondary-200 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 group-hover:bg-accent-100 group-hover:text-accent-600 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm font-label text-foreground-700 group-hover:text-foreground-900 font-medium whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}